import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'
import FlexRow from '../../../../components/molecules/FlexRow'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'

const useStyles = makeStyles((theme) => ({
  toolCall: {
    marginTop: 'var(--margin-sm)',
    marginBottom: 'var(--margin-xs)',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  toolHeader: {
    padding: 'var(--padding-sm) 0',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  expandIcon: {
    fontSize: '16px',
    transition: 'transform 0.2s ease',
    color: 'var(--dai-color-text)'
  },
  expandIconRotated: {
    transform: 'rotate(90deg)'
  },
  toolIcon: {
    fontSize: '20px',
    color: 'var(--color-info-500)'
  },
  toolName: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 'var(--font-weight-bold)',
    flex: 1,
    color: 'var(--dai-color-text)'
  },
  toolStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  statusBadge: {
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  statusSuccess: {
    backgroundColor: 'rgba(46, 213, 115, 0.1)',
    color: 'var(--color-success-500)'
  },
  statusError: {
    backgroundColor: 'rgba(255, 71, 87, 0.1)',
    color: 'var(--color-danger-500)'
  },
  statusPending: {
    backgroundColor: 'rgba(255, 193, 7, 0.1)',
    color: 'var(--color-warning-500)'
  },
  duration: {
    fontSize: 'var(--font-size-xs)'
  },
  toolDetails: {
    padding: 'var(--padding-sm)',
    borderTop: 'var(--dai-border1)'
  },
  section: {
    marginBottom: 'var(--margin-sm)',
    '&:last-child': {
      marginBottom: 0
    }
  },
  sectionTitle: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    marginBottom: '8px',
    textTransform: 'uppercase'
  },
  codeBlock: {
    backgroundColor: 'var(--dai-color-input)',
    color: 'var(--dai-contrast-input)',
    padding: 'var(--padding-sm)',
    borderRadius: '6px',
    fontSize: '12px',
    fontFamily: 'var(--font-family-monospace)',
    overflow: 'auto',
    maxHeight: '300px',
    border: 'var(--dai-border1)',
    lineHeight: 1.5
  },
  errorText: {
    color: 'var(--color-danger-500)',
    fontSize: 'var(--font-size-sm)'
  },
  loadingIndicator: {
    animation: '$rotate 1s linear infinite'
  },
  '@keyframes rotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  }
}))

function ToolCallVisualizer ({ eventId, type, subType, name, data, status }) {
  const classes = useStyles()
  const [showDetails, setShowDetails] = useState(false)

  const getStatusClass = () => {
    switch (status) {
      case 'success':
        return classes.statusSuccess
      case 'error':
        return classes.statusError
      case 'pending':
      default:
        return classes.statusPending
    }
  }

  return (
    <FadeIn className='font-sans radius-sm'>
      <div
        className={classes.toolHeader}
        onClick={() => setShowDetails(!showDetails)}
      >
        <Icon
          name='build'
          style={{
            fontSize: '14px',
            animation: status === 'pending' ? 'rotate 1s linear infinite' : 'none'
          }}
        />
        <span className={classes.toolName}>{name}</span>

        <div className={classes.toolStatus}>
          <span className={`${classes.statusBadge} ${getStatusClass()}`}>
            {status}
          </span>
          {/* {duration ? ( */}
          {/*  <span className={classes.duration}> */}
          {/*    {formatDuration(duration)} */}
          {/*  </span> */}
          {/* ) : null} */}
        </div>
      </div>

      {showDetails ? (
        <FadeIn className={classes.toolDetails}>
          {/* {parameters && Object.keys(parameters).length > 0 ? ( */}
          {/*  <div className={classes.section}> */}
          {/*    <div className={classes.sectionTitle}>Parameters</div> */}
          {/*    <pre className={classes.codeBlock}> */}
          {/*      {JSON.stringify(parameters, null, 2)} */}
          {/*    </pre> */}
          {/*  </div> */}
          {/* ) : null} */}

          {status === 'pending' ? (
            <div className={classes.section}>
              <FlexRow className='justify-center gap-sm'>
                <Icon
                  name='refresh'
                  className={classes.loadingIndicator}
                  style={{ fontSize: '16px', color: 'var(--color-warning-500)' }}
                />
                <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-neutral-400)' }}>
                  Executing...
                </span>
              </FlexRow>
            </div>
          ) : null}

          {/* {status === 'success' && result ? ( */}
          {/*  <div className={classes.section}> */}
          {/*    <div className={classes.sectionTitle}>Result</div> */}
          {/*    <pre className={classes.codeBlock}> */}
          {/*      {typeof result === 'object' ? JSON.stringify(result, null, 2) : String(result)} */}
          {/*    </pre> */}
          {/*  </div> */}
          {/* ) : null} */}

          {/* {status === 'error' && error ? ( */}
          {/*  <div className={classes.section}> */}
          {/*    <div className={classes.sectionTitle}>Error</div> */}
          {/*    <div className={classes.errorText}> */}
          {/*      {error} */}
          {/*    </div> */}
          {/*  </div> */}
          {/* ) : null} */}
        </FadeIn>
      ) : null}
    </FadeIn>
  )
}

ToolCallVisualizer.propTypes = {
  eventId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  subType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.shape({
    content: PropTypes.string,
    toolCallId: PropTypes.string
  }),
  status: PropTypes.oneOf(['success', 'error', 'pending'])
}

export default ToolCallVisualizer
